export default __webpack_public_path__ + "static/media/__quickcam_logo.a62fde67.svg";